import React from 'react';
import PropTypes from 'prop-types';
import { capitalize } from 'lodash';

import SpeakerCard from '../../Speakers/components/SpeakerCard';
import './TalkInformation.scss';

export const TalkInformation = ({
  id,
  title,
  proficiency,
  liveCoding,
  summary,
  speakers,
  speakersTitle,
  talkType,
  technicalOrBusiness,
  video,
  room,
  conferenceDay,
  startTime,
  endTime,
  color
}) => {
  const styles = speakers.length === 0 ? { paddingBottom: '50px' } : null;
  // const feedbackBtn =
  //   track === 'Hands-on Lab' ? (
  //     <a
  //       className="button is-large"
  //       href={`${window.location.pathname}#${location.pathname}/ff`}
  //       id="blue-button"
  //       rel="noopener noreferrer"
  //       style={{ marginTop: '50px' }}>
  //       FEEDBACK FORM
  //     </a>
  //   ) : null;

  return (
    <div key={id} className="column is-four-fifths is-12-mobile talk-detail" style={styles}>
      <div>
        <div className="talk-info-wrapper">
          <h1 className="title talk-title">{title}</h1>
          <div className="talk-room">
            <span className={`${!room ? 'is-hidden' : ''}`}>
              {' '}
              <i className={`fa fa-map-marker-alt track-${color} room-icon`} />
              {room}
            </span>
          </div>
          <div className="talk-info-rows">
            <div className={`track-indicator track-${color}-color`} />
            <div className="talk-difficulty">
              <span className={`${video ? 'video' : 'is-hidden'}`}>
                <a href={video} id="video-link" rel="noopener noreferrer" target="_blank">
                  <i className="fab fa-youtube-square" id="video-link" /> Talk video
                </a>
              </span>

              <span className={`${!technicalOrBusiness ? 'is-hidden' : ''}`}>
                <div className="info-bold">{capitalize(technicalOrBusiness)} talk</div>
              </span>
              <span className={`${liveCoding ? '' : 'is-hidden'}`}>
                <div className="info-bold">Includes Livecoding</div>
              </span>
              <span className={`${!proficiency ? 'is-hidden' : ''}`}>
                <div className="info-bold">Proficiency: </div> {capitalize(proficiency)}
              </span>
              <span className={`${!talkType ? 'is-hidden' : ''}`}>
                <div className="info-bold">Talk Level: </div>
                {capitalize(talkType)}
              </span>
              <span>
                <div className="info-bold">Date: </div>
                {conferenceDay === 'day1' ? 'Oct 19, 2022' : 'Oct 20, 2022'}
              </span>
              <span>
                <div className="info-bold">Time:</div>
                {startTime} - {endTime}
              </span>
            </div>
          </div>
        </div>
        <div className="underline" />
        <p className="description">{summary}</p>
        {/* {feedbackBtn} */}
        <div className="underline" />
      </div>
      {speakers.length > 0 ? (
        <div className="speakers-part">
          <h4 className="title talk-title">{speakersTitle}</h4>
          <div className="columns is-multiline">
            {speakers &&
              speakers.map((speaker, i) => {
                const speakerObj =
                  typeof speaker === 'object'
                    ? { ...speaker }
                    : { id: `unknown${i}`, name: speaker };
                return (
                  <SpeakerCard
                    key={speakerObj.id}
                    company={speakerObj.company || ''}
                    country={speakerObj.country || ''}
                    id={speakerObj.id}
                    name={speakerObj.name || ''}
                    photo={speakerObj.photo || ''}
                  />
                );
              })}
          </div>
        </div>
      ) : null}
    </div>
  );
};

TalkInformation.defaultProps = {
  speakersTitle: 'Speakers',
  room: '',
  conferenceDay: '',
  startTime: '',
  endTime: '',
  color: ''
};

TalkInformation.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  conferenceDay: PropTypes.string,
  endTime: PropTypes.string,
  id: PropTypes.string.isRequired,
  liveCoding: PropTypes.bool.isRequired,
  proficiency: PropTypes.string.isRequired,
  room: PropTypes.string,
  speakers: PropTypes.arrayOf(PropTypes.any).isRequired,
  speakersTitle: PropTypes.string,
  startTime: PropTypes.string,
  summary: PropTypes.string.isRequired,
  talkType: PropTypes.string.isRequired,
  technicalOrBusiness: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  video: PropTypes.string.isRequired
};

export default TalkInformation;
